import { alertClasses } from "@mui/material";
import { Field, Form, Formik } from "formik";
import React from "react";
import { useState } from "react";
import userService from "../../../services/user.service";
import validationSchema from "../../../Validation/ValidationSchemas";
import {
  openFailDialog,
  openSuccessPopup,
} from "../../../Redux/Actions/PopupActions";
import { useDispatch } from "react-redux";
export const NewsletterSection = () => {
  const dispatch = useDispatch();
  const handleSubmit = ({ email }) => {
    userService
      .addNewsLetter(email)
      .then(() => {
        openSuccessPopup(dispatch, {
          successPopUp: {
            message: "Registration Successfull",
            open: true,
          },
        });
      })
      .catch((err) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Something Went Wrong",
        });
      });
  };
  return (
    <section className="newsletter-container pd-block-30">
      <div className="newsletter-heading">Signup to our Newsletters</div>
      <Formik
        initialValues={{
          email: "",
        }}
        validationSchema={validationSchema.newsLetterSignupSchema}
        onSubmit={(values) => handleSubmit(values)}
      >
        {(formik) => (
          <Form>
            <div className="d-flex-align-cent">
              <Field
                className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel specialselect ${
                  formik.errors.email && "is-invalid"
                }`}
                type="text"
                name="email"
                id="firstName"
                placeholder="Enter Email Address"
              />
              <button
                className={`newsletter-submit-btn ${
                  formik.errors.email && "disabled"
                }`}
                disabled={!formik.isValid}
              >
                Submit
              </button>
            </div>
            <div className="errorMessage fs-14 medium">
              {formik.errors.email}
            </div>
          </Form>
        )}
      </Formik>
    </section>
  );
};
